module.controller(
    'AnalysisCtrl',
    [ '$scope', '$rootScope', '$state', 'regulationService', 'alertService','analysisService', 'regulationService',
        function($scope, $rootScope, $state, regulationService, alertService, analysisService, regulationService) {


    		//$scope.idAnalysis = $state.params.idAnalysis;
            $scope.analysis = [];
            $scope.loading = false;
            $scope.filter = {};
            $scope.pagination = {
                    current : 1,
                    total : 0
                };

            /**
             *
             * @param idUser
             */
            $scope.search = function(page) {
                $scope.loading = true;
                
                page = page == undefined ? 1 : page;
                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;
                filter.visible = $scope.filter.visible;

                if($scope.filter.name){
                    filter.name = $scope.filter.name;
                }
                
                analysisService.searchRegulations(filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();
                    $scope.analysis = result;
                    $scope.pagination.total = result.length;
                }, function(response) {
                    $scope.loading = false;
                });
            };
            
            $scope.remove= function(idAnalysis){
            	var a = $scope.analysis.find(function(a){ return a.id == idAnalysis; })
                alertService.showSwtQuestion('Eliminar análisis "'+ a.name +'"', function() {
                    $scope.loading = true;

                    analysisService.removeAnalysis(idAnalysis).then(function(response) {
                        $scope.loading = false;
                        $scope.search(1);
                        alertService.showSuccess('Análisis eliminado satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };
            
            $scope.changeAnalysisState = function(idAnalysis, state){
            	if(state){
            		analysisService.enableAnalysis(idAnalysis).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess('Análisis activo nuevamente en el sistema');
            		}, function(response) {
            			$scope.loading = false;	
            		}); 
            	}
            	else{
            		analysisService.disableAnalysis(idAnalysis).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess('Análisis inactivo');
            		}, function(response) {
            			$scope.loading = false;	
            		}); 
            	}
            };
            
            
            $scope.clearFilters = function(){
            	$scope.filter = {};
            };
            $scope.search(1);
            
        } ]);


